_state$velocityCheck2